import React, { Component } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { BeatLoader } from 'react-spinners';

import { FormId } from 'constants/formId';
import { ClientsActionTypes } from 'api/clients/clients.action-types';
import { PageTitle } from 'components/pages/pageTitle';
import * as PermissionsHelper from 'helpers/permissionsHelper';
import { ClientsUserFormModal } from './form/ClientsUserFormModal';
import { ClientsUsersList } from './list/clients-users-list';
import { ClientsUserPasswordModal } from './password-modal/clients-users-password-modal';
import { ClippingPlatformState } from 'store/clippingPlatformState';
import { callApi } from 'helpers/callApi/callApi';
import { fetchClient } from 'api/clients/clients.actions';
import { NormalizedClient } from 'models/normalized/normalizedClient';

type ClientsUsersPageProps = RouteComponentProps<{ id: string }> & {
  fetchClientDetails: Function;
  client: NormalizedClient | undefined;
};

export class ClientsUsersPage extends Component<ClientsUsersPageProps> {
  componentDidMount() {
    const {
      fetchClientDetails,
      match: {
        params: { id },
      },
      client,
    } = this.props;

    if (!client) {
      callApi({
        action: () => fetchClientDetails(id),
      });
    }
  }

  render() {
    const { client } = this.props;
    const name = typeof client === 'undefined' ? <BeatLoader /> : client.name;

    return (
      <>
        <PageTitle displayTitle="Clients users" subtitles={[name]}>
          {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.CreateClient) && (
            <ClientsUserFormModal
              formTitle="Add user"
              submitActionType={ClientsActionTypes.ADD_CLIENT_USERS_REQUEST}
              formId={FormId.ClientsUserAdd}
            />
          )}
        </PageTitle>
        {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.GetClients) && <ClientsUsersList />}
        {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.CreateClient) && <ClientsUserPasswordModal />}
      </>
    );
  }
}

const clientsSelector = (state: ClippingPlatformState) => state.entities.clients;

const getClient = (state: ClippingPlatformState, id: string) => {
  const { byId } = clientsSelector(state);

  return byId[id];
};

const mapStateToProps = (
  state: ClippingPlatformState,
  {
    match: {
      params: { id },
    },
  }: RouteComponentProps<{ id: string }>,
) => {
  const client = getClient(state, id);

  return {
    client,
  };
};

const mapDispatchToProps = (dispatch: Function) => ({
  fetchClientDetails: (id: string) => dispatch(fetchClient(id)),
});

export const ClientsUsersPageContainer = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(ClientsUsersPage) as React.ComponentType;
